import React from 'react'
import GirlsWeightclasses from './GirlsWeightclasses'
import BoysWeightclasses from './BoysWeightclasses'
import { useNavigate, useLocation } from 'react-router-dom'
import RankingsTable from './RankingsTable'
import CenterClassButtons from './CenterClassButtons'
import FourA_Boys_Team from '../images/4a_boys_team_2_5_25.png'
import ThreeA_Boys_Team from '../images/3a_boys_team_2_5_25.png'
import TwoA_Boys_Team from '../images/2a_boys_team_2_5_25.png'
import OneA_Boys_Team from '../images/1a_boys_team_2_5_25.png'
import OneB_Boys_Team from '../images/1b_boys_team_2_5_25.png'
import FourA_Girls_Team from '../images/4a_girls_team_2_5_25.png'
import ThreeA_Girls_Team from '../images/3a_girls_team_2_5_25.png'
import SS_Girls_Team from '../images/SS_girls_team_2_5_25.png'
import P4P_Boys1 from '../images/P4P_Boys_1-10_Jan_13_2025.png'
import P4P_Boys2 from '../images/P4P_Boys_11-19_Jan_13_2025.png'
import P4P_Girls1 from '../images/P4P_Girls_1-10_Jan_13_2025.png'
import P4P_Girls2 from '../images/P4P_Girls_11-19_Jan_13_2025.png'
import Westbrook_Image from '../images/WESTBROOK_LOGO.png'
import { Link } from 'react-router-dom'

const navigate = useNavigate


const Rankings = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const genderSet = location.pathname.split("/");
  const weightSet = () => {
    let weightclassComponent = null;
    if (genderSet[2] == "g" && genderSet.length > 3) {
      weightclassComponent = <GirlsWeightclasses/>
    } 
    if (genderSet[2] == "b" && genderSet.length > 3) {
      weightclassComponent = <BoysWeightclasses/>
    } 
    return weightclassComponent;
  }

  const centerSet = () => {
    let centerComponent = null;
    if (genderSet[1] == "rankings") {
      return (
        <>
          <h1 className='p4p_header' >Preseason rankings coming this fall!</h1>
        </>
      )
    }
    if (genderSet.length < 4) {
      centerComponent = <CenterClassButtons/>
    }
    if (genderSet[2] == "g" && genderSet.length > 3) {
      centerComponent = <RankingsTable/>
    } 
    if (genderSet[2] == "b" && genderSet.length > 3) {
      centerComponent = <RankingsTable/>
    } 
    if (genderSet[2] == "p4pg") {
      return (
        <>
          <h1 className="p4p_header" >Released 1/13/2025</h1>
          <div className="p4p_centering_images">
            <img class="p4p_rankings_images" src={P4P_Girls1} alt="Pound for Pound Girls Rankings" /> 
            <img class="p4p_rankings_images" src={P4P_Girls2} alt="Pound for Pound Girls Rankings" /> 
          </div>
          <div className="align_end">
            <Link className="" to="/rankings/p4pb">
              <button className="p4p_shortcut">P4P Boys</button>
            </Link>   
          </div>
          <div className="sponsors">
              <img className="westbrook_image" src={Westbrook_Image} alt="" />
          </div>   
        </>
      ) 
    }
    if (genderSet[2] == "p4pb") {
      return (
        <> 
          <h1 className="p4p_header" >Released 1/13/2025</h1>  
          <div className="p4p_centering_images">
            <img class="p4p_rankings_images" src={P4P_Boys1} alt="Pound for Pound Girls Rankings" /> 
            <img class="p4p_rankings_images" src={P4P_Boys2} alt="Pound for Pound Girls Rankings" /> 
          </div> 
          <div className="align_end">
            <Link className="" to="/rankings/p4pg">
              <h1 className="p4p_shortcut">P4P Girls</h1>
            </Link>   
          </div>
          <div className="sponsors">
              <img className="westbrook_image" src={Westbrook_Image} alt="" />
          </div>   
        </>
      ) 
    }
    if (genderSet[2] == "cs") {
      return (
        <>
          <h1 className="p4p_header" >B Boys <br/> <br/> COMING SOON</h1>
        </>
      )
    }
    return centerComponent;
  } 

// const teamRankingsImg = () => {
//   if (genderSet[3] == "4ag") {
//       return (
//           <>
//             <img class="team_rankings_images" src={FourA_Girls_Team} alt="4A Team Rankings" />
//             <div className="sponsors">
//               <img className="westbrook_image" src={Westbrook_Image} alt="" />
//             </div>        
//           </>
//       )
//   } else if (genderSet[3] == "3ag") {
//       return (
//           <>
//             <img class="team_rankings_images" src={ThreeA_Girls_Team} alt="3A Team Rankings" />
//             <div className="sponsors">
//               <img className="westbrook_image" src={Westbrook_Image} alt="" />
//             </div>    
//           </>
//      )
//   } else if (genderSet[3] == "2ag") {
//       return (
//           <>
//             <img class="team_rankings_images" src={SS_Girls_Team} alt="Small School Team Rankings" />
//             <div className="sponsors">
//               <img className="westbrook_image" src={Westbrook_Image} alt="" />
//             </div>    
//           </>
//      )
//   } else if (genderSet[3] == "1a1b2bg") {
//       return (
//           <>
//             <img class="team_rankings_images" src={SS_Girls_Team} alt="Small School Team Rankings" />
//             <div className="sponsors">
//               <img className="westbrook_image" src={Westbrook_Image} alt="" />
//             </div>    
//           </>
//      )
//   } else if (genderSet[3] == "4ab") {
//       return (
//           <>
//             <img class="team_rankings_images" src={FourA_Boys_Team} alt="4A Team Rankings" />
//             <div className="sponsors">
//               <img className="westbrook_image" src={Westbrook_Image} alt="" />
//             </div>    
//           </>
//       )
//   } else if (genderSet[3] == "3ab") {
//       return (
//           <>
//             <img class="team_rankings_images" src={ThreeA_Boys_Team} alt="3A Team Rankings" />    
//             <div className="sponsors">
//               <img className="westbrook_image" src={Westbrook_Image} alt="" />
//             </div>   
//           </>
//       )
//   } else if (genderSet[3] == "2ab") {
//       return (
//           <>
//             <img class="team_rankings_images" src={TwoA_Boys_Team} alt="2A Team Rankings" />  
//             <div className="sponsors">
//               <img className="westbrook_image" src={Westbrook_Image} alt="" />
//             </div>     
//           </>
//       )
//   } else if (genderSet[3] == "1ab") {
//       return (
//           <>
//             <img class="team_rankings_images" src={OneA_Boys_Team} alt="1A Team Rankings" />  
//             <div className="sponsors">
//               <img className="westbrook_image" src={Westbrook_Image} alt="" />
//             </div>     
//           </>
//       )
//   } else if (genderSet[3] == "bb") {
//     return (
//         <>
//           <img class="team_rankings_images" src={OneB_Boys_Team} alt="1B Team Rankings" />  
//           <div className="sponsors">
//             <img className="westbrook_image" src={Westbrook_Image} alt="" />
//           </div>     
//         </>
//     )
// }
// }




  return (
    <div class="flex body_component" >
      <div class="">
        <div class="rankings_box_component">
          {weightSet()}
        </div>
      </div>
      <div className="table_and_team">
        <div>
          {centerSet()}
        </div>
        <div className="team_img_div">
          {/* {teamRankingsImg()} */}
        </div>
      </div>
      {/* BELOW DIV WENT HERE  */}
    </div>
  )
}

      // <div class="">
      //   <div class="rankings_box_component">


      //       {/* <Instagram/> */}
      //   </div>
      // </div>
export default Rankings